import { string, object } from 'yup';

export const validationSchema = object().shape({
  username: string().nullable().required('The username is required'),
  password: string().nullable().required('The password is required'),
});
